"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.offerDetailContextDefaultValue = void 0;
// istanbul ignore file -- constants
const offerDetailContextDefaultValue = exports.offerDetailContextDefaultValue = {
    expiringPoints: 0,
    isCampaignOffer: false,
    isValidityVisible: false,
    loading: false,
    loadMoreEnabled: false,
    offer: {
        availablePoints: null,
        availableUnits: 0,
        choiceId: -1,
        combineChoiceId: -1,
        isSelected: false,
        maxAmountToSpend: null,
        maxQuantityToBuy: null,
        maxQuantityToBuyPerItem: null,
        offerDescription: '',
        offerLayout: '',
        offerMessage: '',
        offerSubTitle: null,
        offers: [],
        offerTitle: '',
        offerType: '',
        priority: 0,
        renderEditBtn: false,
        selectedItemsTotalAmount: null,
        selectedItemsTotalBp: null,
        selectedItemsTotalPoints: null,
        selectedItemsTotalPrice: null,
        showBp: false,
        showPoints: false,
        showSearchBox: false,
        totalCataloguePrice: '',
        totalPoints: null,
        totalPrice: '',
        totalPriceValue: 0,
        validTo: null
    },
    offerItems: [],
    offerValidity: '',
    pointsExpirationDays: 0,
    remainingAmount: undefined,
    remainingQuantity: 99,
    selectedOfferItems: [],
    totalRecords: 0,
    updatingProducts: false,
    loadMore: ()=>{},
    onChangeQuantity: ()=>{},
    setSearchTerm: ()=>{}
};
